import { createContext, useContext } from 'react';

export interface NavigationContextValue {
  path: string;
  navigate: (path: string, options?: { replace?: boolean }) => void;
}

const NavigationContext = createContext<NavigationContextValue | null>(null);

export function NavigationProvider({ value, children }: { value: NavigationContextValue; children: React.ReactNode }) {
  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>;
}

export function useNavigation() {
  const ctx = useContext(NavigationContext);
  if (!ctx) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return ctx;
}
